// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.WebRtcReset in webRtc/webRtc.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.sanitize
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Live view reset message
 *
 * @property config Platform or framework specific request/response configuration or details
 */
public class WebRtcReset(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val config: String = "",
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<WebRtcReset, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is WebRtcReset) return false
    if (unknownFields != other.unknownFields) return false
    if (config != other.config) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + config.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """config=${sanitize(config)}"""
    return result.joinToString(prefix = "WebRtcReset{", separator = ", ", postfix = "}")
  }

  public fun copy(config: String = this.config, unknownFields: ByteString = this.unknownFields): WebRtcReset = WebRtcReset(config, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<WebRtcReset> = object : ProtoAdapter<WebRtcReset>(
      FieldEncoding.LENGTH_DELIMITED, 
      WebRtcReset::class, 
      "type.googleapis.com/vreo.volt.protocol.WebRtcReset", 
      PROTO_3, 
      null, 
      "webRtc/webRtc.proto"
    ) {
      override fun encodedSize(`value`: WebRtcReset): Int {
        var size = value.unknownFields.size
        if (value.config != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(1, value.config)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: WebRtcReset) {
        if (value.config != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.config)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: WebRtcReset) {
        writer.writeBytes(value.unknownFields)
        if (value.config != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.config)
        }
      }

      override fun decode(reader: ProtoReader): WebRtcReset {
        var config: String = ""
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> config = ProtoAdapter.STRING.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return WebRtcReset(
          config = config,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: WebRtcReset): WebRtcReset = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
